var map = {
	"./appointments.svg": 45537,
	"./award-procedure.svg": 55976,
	"./award-units.svg": 10044,
	"./basic-data.svg": 79312,
	"./building.svg": 65197,
	"./conversations.svg": 73234,
	"./envelope.svg": 75906,
	"./log-out.svg": 17061,
	"./notices.svg": 57651,
	"./offers.svg": 28830,
	"./participants.svg": 29150,
	"./permissions.svg": 20637,
	"./requests-for-participation.svg": 42260,
	"./shipments.svg": 97224,
	"./table-of-offers.svg": 43383,
	"./user-squared.svg": 52625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13381;